import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import React from "react";
import CommonButton from "../../../../component/Button";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { Field, Form, Formik } from "formik";
import CommonTextField from "../../../../component/Input";
import * as Yup from "yup";
import XCloseIco from "../../../../assets/icons/XCloseIco";

export default function AddQuestion({
  addQuestion,
  handleAddQuestionClose,
  handleSubmit,
}) {
  const initialValues = {
    question: "",
  };

  const validationSchema = Yup.object({
    question: Yup.string().required("Question is required"),
  });
  return (
    <Dialog
      open={addQuestion.open}
      onClose={handleAddQuestionClose}
      maxWidth={"sm"}
      fullWidth
    >
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={async (values, actions) => {
          handleSubmit(values);
        }}
      >
        {({ values, setFieldValue }) => {
          return (
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") e.preventDefault();
              }}
            >
              <DialogActions sx={{ position: "absolute", right: "0px" }}>
                <Button onClick={handleAddQuestionClose}>
                  <XCloseIco />
                </Button>
              </DialogActions>
              <DialogContent>
                <Typography variant="h3">Add Question</Typography>
                <CommonGrid2
                  display="flex"
                  gap="0.5rem"
                  flexDirection={"column"}
                  marginTop={"1rem"}
                >
                  <Typography variant="body2">Enter Question</Typography>
                  <Field name={"question"}>
                    {({ field, form }) => {
                      return (
                        <CommonTextField
                          value={values.question}
                          onChange={(e) =>
                            setFieldValue("question", e.target.value)
                          }
                          placeholder="Enter the name"
                          placeholderFontSize={"15px"}
                          fontSize={"15px"}
                          padding={"12px"}
                          error={Boolean(
                            form.touched.question && form.errors.question
                          )}
                          helperText={
                            form.touched.question && form.errors.question
                          }
                        />
                      );
                    }}
                  </Field>
                </CommonGrid2>
                <CommonGrid2
                  display="flex"
                  gap="1rem"
                  marginTop={"1.5rem"}
                  justifyContent="flex-end"
                >
                  <CommonButton
                    value={"Cancel"}
                    padding={"8px 2rem"}
                    fontSize={"14px"}
                    fontWeight={600}
                    variant="outlined"
                    disabled={addQuestion.disabled}
                    onClick={handleAddQuestionClose}
                  />
                  <CommonButton
                    value={"Add"}
                    padding={"8px 2rem"}
                    fontSize={"14px"}
                    fontWeight={600}
                    type="submit"
                    disabled={addQuestion.disabled}
                    loading={addQuestion.saveLoading}
                  />
                </CommonGrid2>
              </DialogContent>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
}
